import { useFormContext } from 'react-hook-form'
import { OnboardingFieldNames } from '@/modules/surveys/configs/onboarding/base-config'
import {
  PHYSICIAN_PROFESSION_ID,
  professionOptions,
  professionCodeMap,
  WorkStatus,
} from '@/modules/surveys/configs/onboarding/personal-info-config'
import { OnboardingAccountType } from '@/modules/surveys/configs/onboarding/constants'

export function useProfessionField() {
  const form = useFormContext()
  if (!form) {
    return { professionField: '', accountType: '' }
  }

  const { watch } = form
  const accountType = watch(OnboardingFieldNames.AccountType)
  const workStatus = watch(OnboardingFieldNames.ProfileWorkStatus)
  const profession = watch(OnboardingFieldNames.Profession)

  const professionId =
    accountType === OnboardingAccountType.Physician
      ? PHYSICIAN_PROFESSION_ID
      : professionOptions.find((p) => p.id === profession)?.id
  const professionCode = professionId
    ? professionCodeMap[professionId]
    : undefined

  let professionField = 'unknown'
  if (accountType === OnboardingAccountType.Physician) {
    professionField = workStatus
      ? `physician-${workStatus}`
      : 'physician-unknown'
  } else if (accountType === OnboardingAccountType.AdvancedPractice) {
    if (professionCode) {
      const status =
        workStatus === WorkStatus.InTraining ? 'training' : workStatus
      professionField = status ? `${professionCode}-${status}` : professionCode
    }
  } else if (accountType === OnboardingAccountType.Student) {
    professionField = 'student'
  } else if (accountType === OnboardingAccountType.Employer) {
    professionField = workStatus ? `employer-${workStatus}` : 'employer'
  }

  return { professionField, accountType }
}
